/**
 * @description 个人中心接口
 * @auther zhangyuepeng
 * @date 2021/9/13
 */
import { pbrAxios } from '../../common/js/pbrAxios'

/**
 * 我的关注 - 前端——获取关注条件列表
 * @param {Object}params - 请求参数
 *    @param {Number}params.currentpage:页数
 *    @param {Number}params.pagesize:页数
 *    @param {Number}params.userid: 当前用户
 * @returns {AxiosPromise<any>}
 */
const fetchFocusHistory = params => {
  return pbrAxios.post('/front/focus/list', params)
}

/**
 * 我的关注 - 前端——删除关注操作接口
 * @param {Object}params - 请求参数
 *    @param {String}params.id:关注记录编号
 *    @param {Number}params.userid: 当前用户
 * @returns {AxiosPromise<any>}
 */
const deleteFocus = params => {
  return pbrAxios.post('/front/focus/del', params)
}

/**
 * 我的关注 - 前端——国家|行业|企业|项目关注操作
 * @param {Object}params - 请求参数
 *    @param {String}params.from: en:英文 cn:中文
 *    @param {String}params.focuskey: 关注条件拼接的字符串
 *    @param {String}params.country: 国家编号使用 , 拼接的字符串
 *    @param {String}params.industry: 行业编号使用 , 拼接的字符串
 *    @param {String}params.company: 公司编号使用 , 拼接的字符串
 *    @param {String}params.category: 类型编号使用 , 拼接的字符串
 *    @param {String}params.stage: 状态编号使用 , 拼接的字符串
 *    @param {String}params.date: 前端日期编号使用 , 拼接的字符串
 *    @param {String}params.amount: 金额编号使用 , 拼接的字符串
 *    @param {String}params.id: 关注编号
 *    @param {String}params.userid: 当前用户
 * @returns {AxiosPromise<any>}
 */
const updateFocus = params => {
  return pbrAxios.post('/front/focus/save', params)
}

/**
 * 收藏管理-我的收藏
 * @param {Object}params - 请求参数
 *    @param {Number}params.pageNo:页数
 *    @param {Number}params.pageSize: 每页多少条数据
 *    @param {String}params.lang: cn:中文，en:英文 默认为cn
 *    @param {Number}params.type: 1：商机 2：企业 3：项目 4：风险 5:资讯 6：用于手机端
 *    @param {String}params.userid: 当前用户
 * @returns {AxiosPromise<any>}
 */
const getMyFavList = params => {
  return pbrAxios.get('front/userFav/list', { params })
}

// /front/myproject/search
/**
 * 收藏管理-我的收藏
 * @param {Object}params - 请求参数
 *    @param {Number}params.currentpage:页数
 *    @param {Number}params.pagesize:页数
 *    @param {Number}params.userid: 当前用户
 * @returns {AxiosPromise<any>}
 */
const fetchMyProject = params => {
  return pbrAxios.post('/front/myproject/search', params)
}

/**
 * 我的项目---删除项目
 * @param {Object}params - 请求参数
 *    @param {Number}params.id: 项目id
 * @returns {AxiosPromise<any>}
 */
const deleteProject = params => {
  return pbrAxios.get('/front/myproject/deleteMyProject', {params})
}

export default {
  fetchFocusHistory,
  updateFocus,
  deleteFocus,
  getMyFavList,
  fetchMyProject,
  deleteProject

}
